<template>
    <div class="ReExportRules" >
       <table class="rules" v-if="!isText">
        <thead v-if="this.localRules.length>0"><tr><th><h6>Поле</h6></th><th><h6>Источник</h6></th><th><h6>Действия</h6></th></tr></thead>
        <tbody>
            <tr v-for="(rule,index) of localRules" :key="index">
                <td class="toppadding">
                    <el-input class="required" placeholder="tagname" v-model="rule.dest"></el-input>
                    <base-checkbox v-model="rule.required" inline>Обязательное</base-checkbox>
                    <el-input v-if="rule.required" class="required" placeholder="Название" v-model="rule.name"></el-input>
                </td>
                <td class="">
                    <div v-if="rule.type=='input'" class="toppadding">
                        <el-input placeholder="пустое поле" v-model="rule.src"></el-input>
                    </div>
                    <div v-if="rule.type=='values'" class="px-2 ruleValues">
                        <re-export-rules-values v-model="rule.src"/>
                    </div>
                    <div v-if="rule.type=='php'" class="toppadding">
                        <!-- <el-input type="textarea" :autosize="{minRows:2, maxRows:20}" v-model="rule.src"/> -->
                        <ReInputSyntaxHighlight v-model="rule.src" />
                    </div>
                </td>
                <td class="toppadding change-type-button" style="width: 90px;">
                    <base-button v-if="rule.type!='input'" @click="editorSwitch(index,'input')" class="btn btn-icon btn-primary my-0">
                        <i class="tim-icons icon-simple-remove"></i> 
                    </base-button
                    ><base-button v-if="rule.type!='values'" @click="editorSwitch(index,'values')" class="btn btn-icon btn-primary my-0"><i class="tim-icons icon-pencil"></i></base-button
                    ><base-button v-if="rule.type!='php'" @click="editorSwitch(index,'php')" class="btn btn-icon btn-primary my-0">php</base-button>
                </td>
                <!-- <td><base-button v-if="index>0" @click="upRule(index)" class="btn btn-icon btn-primary my-0"> <i class="tim-icons icon-minimal-up"></i> </base-button>
                <base-button v-if="index<localRules.length-1" @click="downRule(index)" class="btn btn-icon btn-primary my-0"><i class="tim-icons icon-minimal-down"></i></base-button>
                <base-button @click="delRule(index)" class="btn btn-icon btn-danger my-0"><i class="tim-icons icon-trash-simple"></i></base-button></td> -->
                <td class="rulesActionbtn toppadding"><base-button v-if="index>0" @click="upRule(index)" class="btn btn-icon btn-primary my-0"> <i class="tim-icons icon-minimal-up"></i> </base-button></td>
                <td class="rulesActionbtn toppadding"><base-button v-if="index<localRules.length-1" @click="downRule(index)" class="btn btn-icon btn-primary my-0"><i class="tim-icons icon-minimal-down"></i></base-button></td>
                <td class="rulesActionbtn toppadding"><base-button @click="delRule(index)" class="btn btn-icon btn-danger my-0"><i class="tim-icons icon-trash-simple"></i></base-button></td>
            </tr>
        </tbody>
       </table>
        <el-input v-if="isText" type="textarea" :autosize="{minRows:10, maxRows:40}" v-model="valueText"/>
        <base-button v-if="!isText" @click="addRule" class="btn btn-primary btn-simple">Добавить правило</base-button>
        <base-button v-if="!isText" @click="switchToText" class="btn btn-primary btn-simple">Текстовый редактор</base-button>
        <base-button v-if="isText" @click="switchToEditor" class="btn btn-primary btn-simple">Обычный редактор</base-button>
        <!-- 
        <div>
            <el-input type="textarea" :autosize="{minRows:2, maxRows:20}" v-model="rule.src"/>
        </div>        
        -->
    </div>
</template>
<script>
import Vue from 'vue';
import ReExportRulesValues from './ReExportRulesValues.vue';
import { Table, TableColumn, Tooltip, Button, Input } from 'element-ui';
import BaseCheckbox from '../components/Inputs/BaseCheckbox.vue';
import ReInputSyntaxHighlight from 'src/our_components/ReInputSyntaxHighlight.vue';


    // import { Select, Option } from 'element-ui';
    export default {
		name: 'ReExportRules',
		components: {
            // [Option.name]: Option,
            // [Select.name]: Select,
            ReExportRulesValues,
            BaseCheckbox,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Tooltip.name]: Tooltip,
            [Button.name]: Button,
            ReInputSyntaxHighlight,
		},
		props: {
			value: String,
            pretty:{
                type:Boolean,
                default: false,
            }
        },
        data () {
			return {
				ver: 1,
				localRules:[],
                isText:false,
                valueText:'',
			}
		},
        watch:{
            value(){
                try{
                    // this.localRules = JSON.parse(this.value);
                    this.readRules(JSON.parse(this.value));
                }catch(e){
                    console.error(e);
                    this.localRules = [];
                }
            },
            
            outRules(value){
                // console.log('exportRules change',value);
                this.$emit('input', value)
                // setTimeout(()=>{this.$emit('input', value)},1000)
                
            },
            /*
            localRules(){
                if(this.localRules.length>this.editor.length)
                    this.editor.length = this.localRules.length;
            },
            */
        },
        computed:{
            /*
            textRules(){
                if(this.localRules.lenth==0) return 'Нет';
                let o,v,l;
                return (this.localRules.map(r=>{
                    o=[];
                    r.forEach(row => {
                        v=[].concat(row.values);
                        l=v.pop();
                        // o[row.catalog] = row.values
                        if(this.catalogs[row.catalog]){
                            o.push((this.catalogs[row.catalog].name)+': '+(
                                v.length>0?v.map(i=>this.catalogs[row.catalog].list[i]).join(', ')+' и ':''
                            )+this.catalogs[row.catalog].list[l])
                        }
                    });
                    return o.join('; ');
                })).join('\n')
            },
            */
            outRules(){
                try{
                    if(this.localRules.length==0) return '{}';
                    let o={};
                    // console.log('localRules',this.localRules);

                    this.localRules
                        .filter(r=>r.dest>'')
                        .forEach(rule=>{o[rule.dest+(rule.required?'*'+rule.name:'')] = this.getRuleOutValue(rule)})
                    // console.log('export rules out',o);
                    return JSON.stringify(o,null,this.pretty?2:null)
                }catch(e){
                    console.error(e);
                    
                }
                return '{}';
            }
        },
        methods:{
            switchToText(){
                this.valueText = JSON.stringify(JSON.parse(this.value),null,4);
                this.isText = true;
            },
            switchToEditor(){
                let check;
                try{
                    check = JSON.parse(this.valueText);
                }catch(e){
                    // console.log('error', e);
                    let err = e.toString();
                    let pos = err.match(/position (\d+)/);
                    let message;
                    if(pos){
                        // console.log(err, Math.max(0, Number(pos[1])-20),Math.min(Number(pos[1])+20,this.valueText.length-1))
                        message = this.valueText.substring(Math.max(0, Number(pos[1]) - 50),Math.min(Number(pos[1]) + 50,this.valueText.length-1));
                    }else{
                        message = err;
                    }
                    // console.log(this.valueText, message);
                    alert('JSON не валиден: ' +e+"\n\n"+ message);
                    return;
                }
                this.value = JSON.stringify(check);
                this.isText = false;
            },
            getRuleOutValue(rule){
                // console.log('Export rules get',rule)
                if(rule.type=='values') return JSON.parse(rule.src);
                if(rule.type=='php') return '<?php '+rule.src;//.replace(/\n/g,'\\n');
                return rule.src;
            },
            editorSwitch(i,type){
                let rule=this.localRules[i];
                if(type=='values'){
                    rule.src='{}'
                }else
                    rule.src='';
                rule.type=type;
            },
            delRule(i){
                this.localRules.splice(i,1);
            },
            upRule(i){
                // let r = this.localRules;
                let e = this.localRules.splice(i,1);
                this.localRules.splice(i-1,0,e[0]);
                // this.$set('localRules',r);
            },
            downRule(i){
                // let r = this.localRules;
                let e = this.localRules.splice(i,1);
                this.localRules.splice(i+1,0,e[0]);
                // this.localRules = r;
            },
            getRuleType(value){
                if(typeof value === 'object' && value !== null) return 'values';
                if(String(value).substring(0,6)=='<?php ') return 'php';
                return 'input';
            },
            getRuleValue(type, value){
                // console.log(type,value);
                if(type=='values') return JSON.stringify(value);
                if(type=='php') return String(value).substring(6);
                return value;
            },            
            readRules(value){
                try{
                    // console.log('export rules read', value);
                    let rules=value;
                    let r;
                    let ruleReg = /^(.*?)((\*)(.*)?)?$/;
                    this.localRules = Object.keys(rules).map(key=>{
                        let rule=key.match(ruleReg)
                        // console.log(key,rule);
                        r={dest:rule[1], type:this.getRuleType(rules[key]), required:rule[3]=='*', name:rule[4]||''}
                        r.src = this.getRuleValue(r.type, rules[key]);
                        // console.log(r,key, rules[key]);
                        return r;
                    })
                }catch(e){
                    console.error(e);
                }
            },
            
            addRule(){
                this.localRules.push({dest:'',src:'',type:'input',required:false,name:''});
            },
            /*
            addRuleRow(index){
                this.localRules[index].push({catalog:'',values:[]})
            },
            loadFilters(){
                // console.log('load obj filters')
                this.$GVO.ApiCall('get_filter_catalogs',{obj:'MyObj'})
                .then((objApi) => {
                    this.catalogs = objApi.data;
                    let v;
                    Object.values(this.catalogs).forEach(c=>{
                        v={};
                        c.options.forEach(o=>{
                            v[o.value] = o.label
                        })
                        c.list = v;
                    })
                    this.catalog_list = Object.keys(objApi.data).map(key=>({label:objApi.data[key].name, value:key}))
                })
            }
            */
        },
        mounted(){
            // this.loadFilters();
            this.readRules(JSON.parse(this.value));
        }
    }
</script>
<style scoped>
.ReExportRules .el-input.required input:placeholder-shown {
        background-color: #ff8888aa;
        border: 1px solid #F84E54 !important;
    }
.ReExportRules >>> .el-textarea__inner {background-color: transparent!important; color: rgba(255, 255, 255, 0.8);}
.white-content .form-group .ReExportRules >>>   .el-textarea__inner {color: #222a42;}
.rules {width: 100%;}
.rules td {
  vertical-align: top;
}
.rules tr td:first-child {
    width: 200px;
}
.toppadding {padding-top: 26px;}
.rulesActionbtn {
    width: 46px;
    text-align: center;
    
}
.change-type-button button:last-child{
    margin-left: 0.5rem !important;
}

.ruleValues {border: 1px dashed #BA54F5; margin-left: 4px; margin-bottom: 10px; padding-bottom: 10px; border-radius: 6px;}
/* .rules th {
  padding: 15px;
} */
</style>